module.exports = __webpack_public_path__ + "a2b35f9d6dea5b0d1945970171ef4dcc.png";


//////////////////
// WEBPACK FOOTER
// ./src/shared/images/logo-dark.png
// module id = 550
// module chunks = 0